const map = {
	"./assessment-empty.png": 41232,
	"./assessment-non-selected.png": 48938,
	"./assessment-non.png": 29034,
	"./assessment-v-selected.png": 6303,
	"./assessment-v.png": 99469,
	"./assessment-x-selected.png": 96497,
	"./assessment-x.png": 17187
};


function webpackContext(req) {
	const id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		const e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 11248;